import { _ } from "libs";

import React, { useEffect } from "react";
import { getPlayerStats } from "../actions";
import moment from "moment";
import Loader from "./loader";
import { Stat } from "../types";
import withRedux from "../withRedux";
import secondsToDaysHoursMinutes from "../actions/secondsToDaysHoursMinutes";

const SeasonStats = ({ stats, getPlayerStats }: { stats: Stat[]; getPlayerStats: any }) => {
	useEffect(() => {
		if (!stats) {
			const day = moment().unix();
			getPlayerStats(day);
		}
	}, []);

	return (
		<div className="dBlock seasonStatistics">
			<h5>{_("statsWidget.heading")}</h5>
			{stats ? (
				<div className="stats">
					<div className="stat">
						<div className="value">{secondsToDaysHoursMinutes(stats[0].simple[0].absolute)}</div>
						<div className="key">{_("stats.time_played")}</div>
					</div>
					<div className="stat">
						<div className="value">{stats[1].simple[0].absolute}</div>
						<div className="key">{_("stats.games")}</div>
					</div>
					<div className="stat">
						<div className="value">{stats[6].references.length}</div>
						<div className="key">{_("stats.clubs")}</div>
					</div>
				</div>
			) : (
				<Loader />
			)}
		</div>
	);
};

function mapStateToProps({ stats }) {
	return { stats };
}
export default withRedux({ getPlayerStats }, mapStateToProps)(SeasonStats);
